import { ReactComponent as Icon } from 'assets/menuWide/sportsbookVertical.svg'
import React from 'react'

export default function VerticalsSportsbookIcon(props: any) {
  return (
    <Icon {...props} />
  )
}